import { useMemo } from 'react';

export const useFlattenedPages = <K extends string, T>(
  key: K,
  pages?: Array<Record<K, T[] | null> | null>
) => useMemo(() => pages?.flatMap((page) => page?.[key] ?? []) ?? [], [pages, key]);
